import LoginGate from './LoginGate';

export default LoginGate;